/**
 * UI types for spinning wheel components
 * These types are used by the frontend components for display and interaction
 */
import Decimal from "decimal.js";

export interface SpinningWheelUIReward {
  id: string; // Wheel position ID (e.g., "66-0") - used for rotation calculation
  completionId?: string; // Backend completion ID (e.g., UUID) - used for claiming reward
  rewardAmount: Decimal;
  rewardSymbol: string;
  icon?: string;
  color: string;
}

export type SpinningWheelUIState = {
  isSpinning: boolean;
  hasSpun: boolean;
  selectedReward: SpinningWheelUIReward | null;
  spinResult: SpinningWheelUIReward | null;
};
